const config = {
  // backendUrl: "http://localhost:30001/",
  // backendUrl: "http://localhost:20001/",
  backendUrl: "https://rainbow.abbasyonline.com/",
  PayFren: "https://payfren.id/",
  Resource: "https://resource.abbasyonline.com/",
};
export default config;
